// ShapePatternEffects.js

// Compute raw pattern values using columns and rows
function computeRawPatternValues(columns, rows, patternName) {
    const patterns = {
        verticalWave:      (i, j) => j * 0.1,
        horizontalWave:    (i, j) => i * 0.1,
        diagonalWave:      (i, j) => (i + j) * 0.1,
        spiral:            (i, j) => Math.sqrt((i - columns / 2) ** 2 + (j - rows / 2) ** 2) * 0.1,
        ripples:           (i, j) => Math.sin(Math.sqrt((i - columns / 2) ** 2 + (j - rows / 2) ** 2) * 2) * 3,
        columns:           (i)    => (i % 2 === 0 ? 1 : 2),
        rows:              (i, j) => (j % 2 === 0 ? 1 : 2),
        checkerboard:      (i, j) => 0.5 + (((i + j) % 2 === 0) ? 0 : 0.5),
        concentricSquares: (i, j) => Math.min(i, j, columns - i - 1, rows - j - 1) * 0.1,
        zigzag:            (i, j) => ((i + (j % 2 === 0 ? 0 : columns - 1 - 2 * i)) % columns) * 0.2,
        random:            ()     => Math.random() * 2
    };

    const currentPattern = patterns[patternName] || patterns.random;
    const rawCells = [];

    for (let j = 0; j < rows; j++) {
        for (let i = 0; i < columns; i++) {
            rawCells.push({ i, j, raw: currentPattern(i, j) });
        }
    }

    return rawCells;
}

// Normalize raw values into [0..1]
function normalizePattern(rawCells, columns, rows) {
    if (rawCells.length === 0) return [];

    let minVal = Infinity;
    let maxVal = -Infinity;

    for (const c of rawCells) {
        if (c.raw < minVal) minVal = c.raw;
        if (c.raw > maxVal) maxVal = c.raw;
    }

    const range = maxVal - minVal || 1;

    return rawCells.map(c => ({
        i: c.i,
        j: c.j,
        normDelay: (c.raw - minVal) / range
    }));
}

// Generate the final pattern array
export function generatePattern(width, height, cellWidth, scale, patternName, shapeType, customCanvas = null, color = '#000') {
    if (width <= 0 || height <= 0 || cellWidth <= 0) return [];

    const columns = Math.floor(width / cellWidth);
    const rows = Math.floor(height / cellWidth);
    if (columns <= 0 || rows <= 0) return [];

    const rawCells = computeRawPatternValues(columns, rows, patternName);
    const normalized = normalizePattern(rawCells, columns, rows);

    const finalPattern = new Array(normalized.length);

    for (let idx = 0; idx < normalized.length; idx++) {
        const cell = normalized[idx];
        finalPattern[idx] = {
            i: cell.i,
            j: cell.j,
            _key: `${cell.i}-${cell.j}`,
            normDelay: cell.normDelay,
            scale: scale,
            cellWidth: cellWidth,
            totalCount: columns * rows,
            shape: shapeType,
            color: color,
            x: Math.round(cell.i * cellWidth),
            y: Math.round(cell.j * cellWidth),
            customCanvas: shapeType === 'custom' ? customCanvas : null
        };
    }

    finalPattern.sort((a, b) => a.normDelay - b.normDelay);
    return finalPattern;
}
